import theme from "app/Theme/Theme";
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const PhotoIcon = ({ width = 31, height = 31, color = "#007EFC" }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 31 31"
      preserveAspectRatio="xMidYMin meet"
    >
      <Circle cx="15.4036" cy="15.7793" r="15" fill="#007EFC" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5774 15.516C21.6631 15.432 21.7311 15.3322 21.7775 15.2223C21.8239 15.1124 21.8478 14.9946 21.8478 14.8756C21.8478 14.7567 21.8239 14.6389 21.7775 14.529C21.7311 14.4191 21.6631 14.3193 21.5774 14.2352L16.0549 8.80821C15.9694 8.72398 15.8679 8.65715 15.756 8.61155C15.6442 8.56595 15.5243 8.54248 15.4033 8.54248C15.2822 8.54248 15.1623 8.56595 15.0505 8.61155C14.9387 8.65715 14.8371 8.72398 14.7516 8.80821L9.22915 14.2352C9.05632 14.4051 8.95923 14.6354 8.95923 14.8756C8.95923 15.1158 9.05632 15.3462 9.22915 15.516C9.40198 15.6859 9.63639 15.7813 9.8808 15.7813C10.1252 15.7813 10.3596 15.6859 10.5325 15.516L15.4033 10.7276L20.2741 15.516C20.3596 15.6003 20.4612 15.6671 20.573 15.7127C20.6848 15.7583 20.8047 15.7817 20.9257 15.7817C21.0468 15.7817 21.1667 15.7583 21.2785 15.7127C21.3903 15.6671 21.4919 15.6003 21.5774 15.516Z"
        fill={theme.colors["neutral.white"]}
      />
      <Path
        d="M16.0551 22.7511C15.8825 22.9208 15.6484 23.0161 15.4043 23.0161C15.1602 23.0161 14.9261 22.9208 14.7535 22.7511C14.5809 22.5815 14.4839 22.3514 14.4839 22.1115V10.353C14.4839 10.1131 14.5809 9.88304 14.7535 9.71341C14.9261 9.54378 15.1602 9.44849 15.4043 9.44849C15.6484 9.44849 15.8825 9.54378 16.0551 9.71341C16.2277 9.88304 16.3247 10.1131 16.3247 10.353V22.1115C16.3247 22.3514 16.2277 22.5815 16.0551 22.7511Z"
        fill={theme.colors["neutral.white"]}
      />
    </Svg>
  );
};

export default PhotoIcon;
